import React, { useState } from 'react';

export const LoginPage = ({ onLogin, onCreateAccount, onForgotPassword }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(''); // Clear previous messages
        try {
            await onLogin(email, password);
            // Navigation will happen in App.js on success
        } catch (error) {
            // Provide user-friendly error messages
            if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
                setMessage('Invalid email or password.');
            } else {
                setMessage('An error occurred during login. Please try again.');
            }
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh]">
            <h2 className="heading-primary-1 text-4xl font-extrabold text-center mb-6">Login</h2>
            <p className="text-lg text mb-6">
                Log in to access your dashboard and profile.
            </p>
            <form onSubmit={handleSubmit} className="w-full max-w-sm card p-8 rounded-lg shadow-md">
                <div className="mb-4">
                    <label htmlFor="email" className="block text-muted text-sm font-bold mb-2">Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="input-field"
                        placeholder="Enter your email"
                        required
                    />
                </div>
                <div className="mb-6">
                    <label htmlFor="password" className="block text-muted text-sm font-bold mb-2">Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="input-field"
                        placeholder="Enter password"
                        required
                    />
                </div>
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4"> {/* Added flex-col and sm:flex-row for mobile responsiveness */}
                    <button type="submit" className="btn btn-primary w-full sm:w-auto">
                        Login
                    </button>
                    <button type="button" onClick={onCreateAccount} className="btn btn-secondary w-full sm:w-auto">
                        Create Account
                    </button>
                </div>
                <div className="mt-4 text-center">
                    <button type="button" onClick={onForgotPassword} className="btn btn-link text-sm font-medium">
                        Forgot Password?
                    </button>
                </div>
                {message && (
                    <p className="text-danger text-sm mt-4 text-center">{message}</p>
                )}
            </form>
        </div>
    );
};